// OL-205: how a copy in a group send is doing, for the tracking view.

/** "2026-10-20" → "Oct 20, 2026". Read as a calendar date, never shifted by time zone. */
export const formatDueDate = (ymd) => {
  if (!ymd) return '';
  const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return String(ymd);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

/** True once the whole due date has passed. */
export const isPastDue = (ymd, now = new Date()) => {
  if (!ymd) return false;
  const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number);
  return now > new Date(y, m - 1, d, 23, 59, 59, 999);
};

/** Label and badge colour for one recipient's copy. */
export const recipientStatus = (doc) => {
  const current = doc?.current_signer;
  if (doc?.status === 'signed') return { label: 'Signed', badge: 'badge-success' };
  if (current?.email_error) return { label: 'Email failed', badge: 'badge-danger' };
  if (current && !current.sent_at) return { label: 'Sending', badge: 'badge-light' };
  if (doc?.status === 'partially_signed') return { label: `Waiting on ${current?.name || 'next signer'}`, badge: 'badge-info' };
  return { label: 'Waiting to sign', badge: 'badge-warning' };
};
